<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('woocommerce orders')"
      :columns="columns"
      :page_length="50"
      :column_search="true"
      :extra_buttons="extra_buttons"
      resource_url="/woocommerce/order/datatables"
      ><template v-slot:buttons>
        <button
          class="button is-secondary is-rounded"
          @click="synch_from_server"
        >
          <span class="icon">
            <i class="fa fa-server"></i>
          </span>
          <span>{{ $t("synch from server") }}</span>
        </button>
      </template></generic-table
    >
    <order-modal
      ref="order_modal"
      @order_updated="refresh"
      @process_order="process_order"
    />
    <edit-order-modal ref="edit_order_modal" @order_updated="refresh" />
    <process-order-modal ref="process_order_modal" />
  </div>
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  get,
  error_message,
  format_currency,
  format_date_time,
} from "@/utils";
import OrderModal from "./order_modal/Index.vue";
import EditOrderModal from "./edit_order_modal/Index.vue";
import ProcessOrderModal from "./process_order_modal/Index.vue";

export default {
  name: "WoocommerceOrdersDatatable",
  components: { GenericTable, OrderModal, EditOrderModal, ProcessOrderModal },
  props: {},
  data() {
    let v = this;
    return {
      extra_buttons: [],
      columns: [
        {
          title: v.$t("customer"),
          searchable: false,
          // width: "35%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return `<div class="title is-6">${
              row.json_data.billing.first_name
            } ${row.json_data.billing.last_name}</div>
                    <div class="subtitle is-6 mb-0">${
                      row.json_data.billing.email
                    }</div>
                    <div class="subtitle is-6 mb-0">${format_date_time(
                      row.json_data.date_created
                    )}</div>`;
          },
        },
        {
          title: v.$t("order"),
          searchable: false,
          // width: "35%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return `<div class="title is-6">${v.$t(
              "order number"
            )} <span class="has-text-primary">${
              row.json_data.number
            }</span></div>
                    <div class="subtitle is-6 mb-0 has-text-warning">${v.$t(
                      row.json_data.status
                    )}</div>`;
          },
        },
        {
          title: v.$t("total"),
          searchable: false,
          // width: "35%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return `<div class="title is-6">${format_currency(
              row.json_data.total
            )}</div>`;
          },
        },
        // {
        //   title: v.$t("data"),
        //   searchable: false,
        //   // width: "10%",
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     // return format_currency(row.balance) || "";
        //   },
        // },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("details"),
                icon: "fa fa-eye",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.order_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  v.$refs.edit_order_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("update"),
                icon: "fa fa-recycle",
                icon_class: "is-small",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to update order from server?"),
                    v,
                    () => {
                      v.$root.loader(true);
                      get("/woocommerce/order/from-server", {
                        uuid: uuid,
                      })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        })
                        .finally(() => {
                          v.$root.loader(false);
                        });
                    }
                  );
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("process order"),
                icon: "fa fa-cogs",
                icon_class: "is-small",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  v.$refs.process_order_modal.show_modal(uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete order?"),
                    v,
                    () => {
                      del("/woocommerce/order", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    synch_from_server() {
      let v = this;
      v.$root.loader(true);
      get("/woocommerce/order/synch")
        .then(() => {
          v.refresh();
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    process_order(uuid) {
      let v = this;
      v.$refs.process_order_modal.show_modal(uuid);
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
